<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 27 27"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.4063 0C7.14741 0 6.93755 0.208933 6.93755 0.466667V4.74631C6.39134 4.93849 6 5.45708 6 6.06667V8.86667C6 9.63987 6.6296 10.2667 7.40625 10.2667C7.45988 10.2667 7.51282 10.2637 7.56489 10.2579C8.61632 12.4699 10.8787 14 13.5 14C16.1214 14 18.3838 12.4699 19.4352 10.2579C19.4872 10.2637 19.5401 10.2667 19.5937 10.2667C20.3704 10.2667 21 9.63987 21 8.86668V6.06667C21 5.45712 20.6087 4.93855 20.0625 4.74635V0.466667C20.0625 0.208934 19.8527 0 19.5938 0C19.3349 0 19.125 0.208933 19.125 0.466667V4.09956C17.9767 2.20225 15.8872 0.933314 13.5 0.933314C11.1129 0.933314 9.02339 2.20226 7.87505 4.09957V0.466667C7.87505 0.208934 7.66518 0 7.4063 0Z"
      fill="#80B7FF"
    />
    <path
      d="M8.62171 15.0436C9.07896 14.9273 9.54173 15.0436 9.8282 15.3927L13.5028 19.609L17.1773 15.3927C17.4638 15.0436 17.9816 14.9328 18.3838 15.0436C23.6119 16.7778 27 21.0495 27 25.842C27 26.4792 26.4821 27 25.8486 27H1.1514C0.517852 27 0 26.4792 0 25.842C0.00550908 21.0495 3.39359 16.7778 8.62171 15.0436Z"
      fill="#80B7FF"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 19 },
    height: { type: [Number, String], default: 20 },
    color: { type: String, default: "#D3D4DE" },
  },
};
</script>
